import React from 'react';

import Avatar from '@atlaskit/avatar';

const AvatarPresenceOnlineExample = (): React.JSX.Element => {
	return <Avatar name="John Smith" presence="online" />;
};

export default AvatarPresenceOnlineExample;
